import type { Map as MapLibreMap } from 'maplibre-gl'

type MapStyleReader = Pick<MapLibreMap, 'getStyle'>

/**
 * Returns the first basemap symbol layer so passive app layers can render below
 * labels, road shields, and POI icons without depending on style-specific IDs.
 */
export const findFirstSymbolLayerId = (map: MapStyleReader): string | undefined =>
  map.getStyle().layers?.find((layer) => layer.type === 'symbol')?.id
